import { useEffect, useRef } from 'react';

/**
 * Anfangsfokus fuer einen Schrittdialog.
 *
 * WARUM noetig: die Schritte liegen als Overlay ueber der Projektliste, aber
 * ohne Fokusfalle. Der Klick auf die Projektzeile laesst den Fokus auf deren
 * Knopf; ein Druck auf Enter oder Leertaste im offenen Schritt loeste ihn
 * erneut aus, die Kette begaenne von vorn und die eben gegebene Antwort war
 * kommentarlos weg. Zusammen mit der Sperre der Zeilen waehrend der Kette
 * (`disabled`) ist der Weg damit zu.
 *
 * Der Rahmen selbst bekommt den Fokus (`tabIndex={-1}`) und nicht der erste
 * Knopf darin: eine Antwortkarte im Fokus sieht aus wie eine getroffene Wahl,
 * und die Eingabetaste bestaetigte sie. Genau das soll hier niemand versehentlich
 * tun.
 *
 * `enabled` gibt es fuer den einen Schritt, der etwas anderes braucht: die
 * Abschlagshoehe wird getippt, dort gehoert der Fokus ins Feld. Ohne diesen
 * Schalter waere das `autoFocus` dort wirkungslos — React setzt es beim
 * Einhaengen, dieser Effekt laeuft danach und holte den Fokus wieder weg. Eine
 * Antwortkarte gibt es in diesem Schritt nicht, also auch nichts, was die
 * Eingabetaste versehentlich bestaetigen koennte.
 */
export const useStepFocus = (enabled = true) => {
    const ref = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (enabled) ref.current?.focus();
    }, [enabled]);
    return ref;
};
